export default __webpack_public_path__ + "static/media/kelas1.f97890d8.png";